<mat-grid-list [cols]="12" rowHeight="125px">
  <mat-grid-tile colspan="2">
    <mat-form-field [hideRequiredMarker]="hideRequired()" [floatLabel]="floatLabel()" [style.marginLeft]="'0.7rem'" [style.width]="'95%'">
      <mat-select [formControl]="httpMethod">
        <mat-option [value]="'GET'">GET</mat-option>
        <mat-option [value]="'POST'">POST</mat-option>
        <mat-option [value]="'PATCH'">PATCH</mat-option>
        <mat-option [value]="'PUT'">PUT</mat-option>
      </mat-select>
      <mat-label>HTTP Method</mat-label>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="9">
    <mat-form-field [style.width]="'98%'">
      <mat-label>API URI</mat-label>
      <input matInput placeholder="Search by Key Name" [formControl]="uri" />
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="rh-btn-container">
      <button class="rh-list-btn" mat-button (click)="runTest()" [disabled]="!isValid">SEND</button>
    </div>
  </mat-grid-tile>
</mat-grid-list>